import React from 'react';
import Modal from 'Components/Modal';
import BetslipModal from 'Components/BetslipModal';
import PropTypes from 'prop-types';
import History from 'Store/history';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';
import { withLastLocation } from 'react-router-last-location';
import LocalStorage from 'Utils/localStorage';
import { getTribunUser, muteTribunUser, followTribunUser } from 'Store/actions';
import { toast } from 'react-toastify';
import ToastTemplate from 'Components/ToastTemplate';

import {
  TribunLoginSuccessModal,
  TribunLoginFailModal,
  TribunPlayModal,
  TribunMultipleEventCheckModal,
  TribunLeaderBoardMiniFailModal,
  TribunLeaderBoardMiniSuccesModal,
  TribunCouponShareFailedModal,
  TribunNonPlayableCouponModal,
  RangeValidationModal
} from './index';
import { useDispatch } from 'react-redux';

const RenderActiveModals = props => {
  const { openModal, closeModal, isModalOpen, addMultipleEventsToBetSlip, createTribunUser, getTribunUserAgreement, tribunUserAgreement, getTribunTermOfUse, tribunTermOfUse } = props;
  const dispatch = useDispatch();
  const {
    tribunLoginSuccessModal,
    tribunPlayModal,
    tribunMultipleEventCheckModal,
    tribunLeaderBoardMiniSuccesModal,
    complaintTribunFailure,
    tribunBlockedUserModal,
    sendCommentFailure,
    uploadAvatarFailure,
    removeAvatarFailure,
    rangeValidationModal,
    tribunCouponShareFailedModal
  } = props.modalData;

  if (isModalOpen('tribunKvkkModal')) {
    return (
      <Modal
        onClose={ () => props.closeModal('tribunKvkkModal') }
        title="Aydınlatma Metni"
        position={ { web: 'center' } }>
        <div dangerouslySetInnerHTML={ { __html: tribunUserAgreement?.data?.content } } />
      </Modal>
    );
  }

  if (isModalOpen('tribunTermOfUseModal')) {
    return (
      <Modal
        onClose={ () => props.closeModal('tribunTermOfUseModal') }
        title="Tribün Kullanım Koşulları ve Genel Kurallar"
        position={ { web: 'center' } }>
        <div dangerouslySetInnerHTML={ { __html: tribunTermOfUse?.data?.content } } />
      </Modal>
    );
  }

  if (isModalOpen('tribunNonPlayableCouponModal')) {
    return (
      <Modal
        iconName="svgInfo"
        onClose={ () => closeModal('tribunNonPlayableCouponModal') }
        buttonArea={ {
          primaryButton: {
            onClick: ()=> {
              closeModal('tribunNonPlayableCouponModal');
            },
            label: 'Tamam',
          }
        } }

      >
        <TribunNonPlayableCouponModal/>
      </Modal>
    );
  }

  if (isModalOpen('tribunLoginSuccessModal')) {
    return (
      <Modal
        iconName="svgTribunGreen"
        title="Tribün’e Hoşgeldin!"
        onClose={ () => {
          createTribunUser(tribunLoginSuccessModal.userId);
          props.closeModal('tribunLoginSuccessModal');
        } }
      >
        <TribunLoginSuccessModal
          openModal={ openModal }
          getTribunUserAgreement={ getTribunUserAgreement }
          getTribunTermOfUse = { getTribunTermOfUse }
          onPrimaryButtonClick={ () => {
            createTribunUser(tribunLoginSuccessModal.userId);
            props.closeModal('tribunLoginSuccessModal');
          } }
          tribunLoginSuccessUserName={ tribunLoginSuccessModal.userName }
        />
      </Modal>
    );
  }
  if (isModalOpen('tribunLeaderBoardMiniFailModal')) {
    return (
      <Modal
        iconName="svgInfoFilled"
        title="Genel Sıralama"
        onClose={ () => closeModal('tribunLeaderBoardMiniFailModal') }
        buttonArea={ {
          primaryButton: {
            onClick: ()=> {
              History.push('/tribun/lider-100');
              closeModal('tribunLeaderBoardMiniFailModal');
            },
            label: 'Lider 100 e Git',
          },
        } }
      >
        <TribunLeaderBoardMiniFailModal/>
      </Modal>
    );
  }
  if (isModalOpen('tribunLeaderBoardMiniSuccesModal')) {
    return (
      <Modal
        type="info"
        onClose={ () => closeModal('tribunLeaderBoardMiniSuccesModal') }
        iconName='svgInfoFilled'
        title="Genel Sıralama"
      >
        <TribunLeaderBoardMiniSuccesModal
          miniLeaderBoard={ tribunLeaderBoardMiniSuccesModal.data.leaderboardResponse }
          currentUserId={ tribunLeaderBoardMiniSuccesModal.currentUserId }
          closeModelProp={ () => {
            closeModal('tribunLeaderBoardMiniSuccesModal');
          } }
        />
      </Modal>
    );
  }
  if (isModalOpen('tribunCouponShareFailedModal')) {
    return (
      <Modal
        type="error"
        iconName='svgPlayFailure'
        title="Kuponun Paylaşılamadı"
        onClose={ () => {
          closeModal('tribunCouponShareFailedModal');
        } }
        buttonArea={ {
          primaryButton: {
            onClick: ()=> {
              closeModal('tribunCouponShareFailedModal');
            },
            label: 'Tamam',
          }
        } }

      >
        <TribunCouponShareFailedModal
          data={ tribunCouponShareFailedModal?.extras?.extraMessages }
          errorCode={ tribunCouponShareFailedModal?.code } />
      </Modal>

    );
  }
  if (isModalOpen('tribunPlayModal')) {
    const title = tribunPlayModal.clickType === 2 ? EnvironmentManager.getMessageText({ key: 'title_clean_coupon_message' }) || 'Yeni Kuponunda Kullan' : null;

    return (
      <Modal
        title={ title }
        iconName="svgNewPlus"
        onClose={ () => closeModal('tribunPlayModal') }
        buttonArea={ {
          primaryButton: {
            onClick: ()=> {
              addMultipleEventsToBetSlip({
                events: tribunPlayModal.events,
                couponDetails: tribunPlayModal.couponDetails,
                source: tribunPlayModal.source,
                sourceId: tribunPlayModal.sourceId,
                feedId: tribunPlayModal.feedId,
                likeCount: tribunPlayModal.likeCount,
                commentCount: tribunPlayModal.commentCount
              }, tribunPlayModal?.validEvents);
              closeModal('tribunPlayModal');
            },
            label: EnvironmentManager.getMessageText({ key: 'tribun_clean_add' }),
          }
        } }

      >
        <TribunPlayModal/>
      </Modal>
    );
  }

  if (isModalOpen('tribunLoginFailModal')) {
    //Bu modalın logic kısımı product tarafı ile konuşulduktan sonra kullanılacak.
    return (
      <Modal
        iconName="svgModalFail"
        title="Başarısız"
        onClose={ () => closeModal('tribunLoginFailModal') }
        buttonArea={ {
          primaryButton: {
            onClick: ()=> {
              closeModal('tribunLoginFailModal');
            },
            label: 'Ana Sayfaya Dön',
          }
        } }
      >
        <TribunLoginFailModal/>
      </Modal>
    );
  }

  if (isModalOpen('tribunUniqueUserNameModal')) {
    return (
      <Modal
        iconName="svgBullhornGreen"
        onClose={ () => {
          props.closeModal('tribunUniqueUserNameModal');
          LocalStorage.remove('tribunNicknameChange');
        } }
        buttonArea={ {
          primaryButton: {
            label: 'Tamam',
            onClick: () => {
              props.closeModal('tribunUniqueUserNameModal');
              LocalStorage.remove('tribunNicknameChange');
            }
          }
        } }
      >
        <Message
          type="none">
          <span>
            { EnvironmentManager.getMessageText({ key: 'tribun_name_generate' }) }
          </span>
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('tribunMultipleEventCheckModal')) {
    return (
      <Modal
        iconName="svgInfoRed"
        title="Maçları Kontol et"
        onClose={ () => closeModal('tribunMultipleEventCheckModal') }
        buttonArea={ {
          primaryButton: {
            onClick: ()=> {
              tribunMultipleEventCheckModal?.nextModal ? tribunMultipleEventCheckModal?.nextModal() : addMultipleEventsToBetSlip({ ...tribunMultipleEventCheckModal }, tribunMultipleEventCheckModal?.validEvents);
              closeModal('tribunMultipleEventCheckModal');
            },
            label: 'Oyna',
          },
          secondaryButton: {
            variant: 'secondary',
            onClick: () =>{
              dispatch(closeModal('tribunMultipleEventCheckModal'));
            },
            label: 'Vazgeç',
          }
        } }
      >
        <TribunMultipleEventCheckModal/>
      </Modal>
    );
  }

  if (isModalOpen('askComplaint')) {
    let type;
    if (props.modalData.askComplaint.type === 'picture') {
      type = ' profil fotoğrafının';
    } else if (props.modalData.askComplaint.type === 'description') {
      type = ' kupon başlığının';
    } else {
      type = ' yorumunun';
    }
    return (
      <Modal
        iconName="svgReportGreen"
        title={ EnvironmentManager.getMessageText({ key: 'tribune_comment_report_comment_modal_title' }) || 'Şikayet Et' }
        onClose={ () => props.closeModal('askComplaint') }
        buttonArea={ {
          primaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'tribune_comment_report_comment_modal_report_button_text' }) || 'Bildir',
            onClick: () => {
              props.modalData.askComplaint.complaintTribun(props.modalData.askComplaint.type, props.modalData.askComplaint.id);
              props.closeModal('askComplaint');
            }
          },
          secondaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'tribune_comment_report_comment_modal_cancel_button_text' }) || 'Vazgeç',
            onClick: () => props.closeModal('askComplaint')
          }
        } }
      >
        <Message type="none">
          <span dangerouslySetInnerHTML={ { __html: (EnvironmentManager.getMessageText({ key: 'tribune_comment_report_comment_modal_description' }) || `%@ adlı kişinin${ type } uygunsuz içerik barındırdığını bildirmek üzeresin.`).replace('%@', `<b>${ props.modalData.askComplaint.userName }</b>`) } } />
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('complaintTribunSuccess')) {
    return (
      <Modal
        iconName="svgLike"
        onClose={ () => props.closeModal('complaintTribunSuccess') }
        buttonArea={ {
          primaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'tribune_comment_report_comment_success_modal_button' }) || 'Tamam',
            onClick: () => props.closeModal('complaintTribunSuccess')
          }
        } }>
        <Message type="none">
          <span>
            { EnvironmentManager.getMessageText({ key: 'tribune_comment_report_comment_success_modal_description' }) }
          </span>
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('complaintTribunFailure')) {
    return (
      <Modal
        iconName="svgModalFail"
        type="error"
        onClose={ () => props.closeModal('complaintTribunFailure') }
        buttonArea={ {
          primaryButton: {
            label: 'Tamam',
            onClick: () => props.closeModal('complaintTribunFailure')
          }
        } }>
        <Message type="none">
          <span>
            { EnvironmentManager.getMessageText({ key: `${complaintTribunFailure.domain}${complaintTribunFailure.code}` }) }
          </span>
        </Message>
      </Modal>
    );
  }
  if (isModalOpen('rangeValidationModal')) {
    const { errorMessage } = rangeValidationModal;

    return (
      <BetslipModal
        iconName="svgInfoPopularOrange"
        position={ { web: 'center' } }
        onClose={ () => {
          props.closeModal('rangeValidationModal');
        } }
        overlayStyle={ { backgroundColor: '#0000004d' } }
        contentStyle={ {
          width: 'unset',
        } }
        overlayClick={ false }
      >
        <RangeValidationModal
          errorMessage={ errorMessage }
          onPrimaryButtonClick={ () => props.closeModal('rangeValidationModal') }
        />
      </BetslipModal>
    );
  }

  if (isModalOpen('tribunBlockedUserModal')) {
    let title;
    const tribun_blocked_popup = EnvironmentManager.getMessageText({ key: 'tribun_blocked_popup' });
    const { origin, date, hours } = tribunBlockedUserModal;
    const { lastLocation, history } = props;
    switch (origin) {
      case 'home':
        title = 'Giriş yapılamadı';
        break;
      case 'betSlip' || 'coupons' || 'kickOff':
        title = 'Kuponun paylaşılamadı';
        break;
      case 'tribun':
        title = EnvironmentManager.getMessageText({ key: 'tribun_popup_title_kickoff' });
        break;
    }

    const _closeModals = () => {
      if (origin === 'tribun') {
        if (lastLocation?.pathname === '/tribun') {
          History.push(history?.location?.state?.lastLocationUrl || '/');
        } else {
          History.goBack();
        }
      }

      props.closeModal('tribunBlockedUserModal');
      props.closeModal('shareOnTribunModal');
    };

    return (
      <Modal
        title={ title }
        iconName="svgModalFail"
        type="error"
        onClose={ () => {
          _closeModals();
        } }
        buttonArea={ {
          primaryButton: {
            label: 'Tamam',
            onClick: () => {
              _closeModals();
            }
          }
        } }
      >
        <Message type="none">
          <span dangerouslySetInnerHTML={ { __html: tribun_blocked_popup.replace('%@', `${date} ${hours}` ) } } />
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('sendCommentFailure')) {
    return (
      <Modal
        iconName="svgModalFail"
        type="error"
        onClose={ () => props.closeModal('sendCommentFailure') }
        buttonArea={ {
          primaryButton: {
            label: 'Tamam',
            onClick: () => props.closeModal('sendCommentFailure')
          }
        } }>
        <Message type="none">
          { EnvironmentManager.getMessageText({ key: `${sendCommentFailure.domain}${sendCommentFailure.code}` }) }
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('commentForbidAllowModal')) {
    const { feedId, forbid, tabType, commentForbidAllow } = props.modalData.commentForbidAllowModal;
    return (
      <Modal
        iconName="svgModalFail"
        type="error"
        onClose={ () => props.closeModal('commentForbidAllowModal') }
        buttonArea={ {
          primaryButton: {
            label: !forbid ? 'Yorumlara Aç' : 'Yorumlara Kapat',
            className: 'btn--tribun',
            onClick: () => {
              commentForbidAllow(feedId, forbid, tabType);
              props.closeModal('commentForbidAllowModal');
            }
          }
        } }>
        <Message type="none">
          { !forbid ? 'Kuponunu yorumlara açmak istediğinden emin misin?' : 'Kuponunu yorumlara kapatmak istediğinden emin misin?' }
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('uploadAvatar')) {
    const { havePhoto, handleImageChange, removeAvatar } = props.modalData.uploadAvatar;
    return (
      <Modal
        title={ !havePhoto ? 'Profil Fotoğrafı Seç' : 'Profil Fotoğrafını Değiştir' }
        iconName="svgUploadPhoto"
        onClose={ () => props.closeModal('uploadAvatar') }
        buttonArea={ {
          primaryButton: {
            label: 'Fotoğraf Yükle',
            onClick: () => {
              handleImageChange();
              props.closeModal('uploadAvatar');
            }
          },
          secondaryButton: havePhoto ? {
            label: 'Fotoğrafı Kaldır',
            className: 'btn--tribun',
            onClick: () => {
              props.closeModal('uploadAvatar');
              props.openModal('removeAvatar', { removeAvatar: () => removeAvatar() });
            }
          } : { label: 'Vazgeç',
            onClick: () => props.closeModal('uploadAvatar') },
        } }>
        <Message type="none"/>
      </Modal>
    );
  }

  if (isModalOpen('uploadAvatarSuccess')) {
    return (
      <Modal
        onClose={ () => {
          dispatch(getTribunUser());
          props.closeModal('uploadAvatarSuccess');
        } }
        buttonArea={ {
          primaryButton: {
            label: 'Tamam',
            onClick: () => {
              dispatch(getTribunUser());
              props.closeModal('uploadAvatarSuccess');
            }
          }
        } }
      >
        <Message type="none">{ EnvironmentManager.getMessageText({ key: 'tribun_profilpic_update' }) }</Message>
      </Modal>
    );
  }

  if (isModalOpen('uploadAvatarFailure')) {
    return (
      <Modal
        iconName="svgModalFail"
        type="error"
        onClose={ () => props.closeModal('uploadAvatarFailure') }
        buttonArea={ {
          primaryButton: {
            label: 'Tamam',
            onClick: () => props.closeModal('uploadAvatarFailure')
          }
        } }>
        <Message type="none">
          <span>
            { EnvironmentManager.getMessageText({ key: `${uploadAvatarFailure.domain}${uploadAvatarFailure.code}` }) }
          </span>
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('removeAvatar')) {
    const { removeAvatar } = props.modalData.removeAvatar;

    return (
      <Modal
        className="remove-avatar-modal"
        iconName="svgReportGreen"
        title="Fotoğrafı Sil"
        onClose={ () => props.closeModal('removeAvatar') }
        buttonArea={ {
          primaryButton: {
            label: 'Sil',
            onClick: () => {
              props.closeModal('removeAvatar');
              removeAvatar();
            }
          },
          secondaryButton: {
            label: 'Vazgeç',
            onClick: () => props.closeModal('removeAvatar')
          }
        } }>
        <Message type="none">
          <span>Profil fotoğrafını silmek istediğinden emin misin?</span>
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('removeAvatarSuccess')) {
    return (
      <Modal
        onClose={ () => props.closeModal('removeAvatarSuccess') }
        buttonArea={ {
          primaryButton: {
            label: 'Tamam',
            onClick: () => {
              props.closeModal('removeAvatarSuccess');
            }
          }
        } }>
        <Message type="none">{ EnvironmentManager.getMessageText({ key: 'tribun_profilpic_remove' }) }</Message>
      </Modal>
    );
  }

  if (isModalOpen('removeAvatarFailure')) {
    return (
      <Modal
        iconName="svgModalFail"
        type="error"
        onClose={ () => props.closeModal('removeAvatarFailure') }
        buttonArea={ {
          primaryButton: {
            label: 'Tamam',
            onClick: () => props.closeModal('removeAvatarFailure')
          }
        } }
      >
        <Message type="none">
          <span>
            { EnvironmentManager.getMessageText({ key: `${removeAvatarFailure.domain}${removeAvatarFailure.code}` }) }
          </span>
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('muteUserModal')) {
    const { userName, userId, tabType } = props.modalData.muteUserModal;

    return (
      <Modal
        iconName="svgInfoPopularOrange"
        title={ EnvironmentManager.getMessageText({ key: 'tribune_mute_user_popup_title' }) }
        className="popular-selections-modal"
        onClose={ () => closeModal('muteUserModal') }
        buttonArea={ {
          primaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'tribune_mute_user_popup_cancel_button' }),
            className: 'btn btn--outline',
            onClick: () => closeModal('muteUserModal'),
          },
          secondaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'tribune_mute_user_popup_action_button' }),
            className: 'btn btn--primary',
            onClick: () => {
              dispatch(muteTribunUser(userId, tabType, userName)).then(() => {
                const currentUserId = LocalStorage.get('tribunUser')?.userId;
                const toastText = EnvironmentManager.getMessageText({ key: 'tribune_mute_user_toaster_text' });
                const parts = toastText.split('Bildirim Ayarları');

                toast(
                  <ToastTemplate type="gray" rightText='Kapat'>
                    { parts[0] }
                    <u
                      style={ { cursor: 'pointer' } }
                      onClick={ () => {
                        History.push(`/tribun/profil/${currentUserId}/ayarlarim?tab=bildirim-ayarlari`);
                      } }
                    >
                      Bildirim Ayarları
                    </u>
                    { parts[1] }
                  </ToastTemplate>,
                  {
                    toastId: 'tribunMuteUser',
                    autoClose: 3000,
                    position: toast.POSITION.BOTTOM_CENTER,
                  }
                );
              }).catch(() => {});
              closeModal('muteUserModal');
            }
          }
        } }
      >
        <Message type="none">
          <span dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'tribune_mute_user_popup_subtitle' }).replace('%@', userName) } } />
        </Message>
      </Modal>
    );
  }

  if (isModalOpen('unfollowUserModal')) {
    const { userName, userId, tabType } = props.modalData.unfollowUserModal;

    return (
      <Modal
        iconName="svgInfoPopularOrange"
        title={ EnvironmentManager.getMessageText({ key: 'tribune_unfollow_user_popup_title' }) }
        className="popular-selections-modal"
        onClose={ () => closeModal('unfollowUserModal') }
        buttonArea={ {
          primaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'tribune_unfollow_user_popup_cancel_button' }),
            className: 'btn btn--outline',
            onClick: () => closeModal('unfollowUserModal'),
          },
          secondaryButton: {
            label: EnvironmentManager.getMessageText({ key: 'tribune_unfollow_user_popup_action_button' }),
            className: 'btn btn--primary',
            onClick: () => {
              dispatch(followTribunUser(false, userId, tabType, userName)).then(() => {
                toast(
                  <ToastTemplate type="gray" rightText='Kapat'>
                    { EnvironmentManager.getMessageText({ key: 'tribune_unfollow_user_toaster_text' }) }
                  </ToastTemplate>,
                  {
                    toastId: 'tribunUnfollowUser',
                    autoClose: 3000,
                    position: toast.POSITION.BOTTOM_CENTER,
                  }
                );
              });
              closeModal('unfollowUserModal');
            }
          }
        } }
      >
        <Message type="none">
          <span dangerouslySetInnerHTML={ { __html: EnvironmentManager.getMessageText({ key: 'tribune_unfollow_user_popup_subtitle' }).replace('%@', userName) } } />
        </Message>
      </Modal>
    );
  }

  return null;
};

RenderActiveModals.propTypes = {
  closeModal: PropTypes.func,
  openModal: PropTypes.func,
  isModalOpen: PropTypes.func,
  createTribunUser: PropTypes.func,
  addMultipleEventsToBetSlip: PropTypes.func,
  modalData: PropTypes.object,
  lastLocation: PropTypes.object,
  history: PropTypes.object,
  getTribunUserAgreement: PropTypes.func,
  getTribunTermOfUse: PropTypes.func,
  tribunUserAgreement: PropTypes.object,
  tribunTermOfUse: PropTypes.object
};

export default withLastLocation(RenderActiveModals);
